import { useTranslation } from 'react-i18next';
import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import TextAreaField from 'components/forms/textAreaField/TextAreaField';
import {
  HouseRulesContainer,
  PreviewDivider,
} from '../PreviewPreArrivalForm.styles';
import useShouldShowField from '../useShouldShowField';
import { PreArrivalFormFields } from '../../PreArrivalFormTab.types';

const HouseRulesSection = () => {
  const { t } = useTranslation();
  const { shouldShowField } = useShouldShowField();

  return (
    <>
      <HouseRulesContainer data-testid="preview-house-rules-section">
        <h2>{t('pageAutomations.preArrivalForm.preview.houseRules.header')}</h2>
        <div>
          <p>
            {t(
              'pageAutomations.preArrivalForm.preview.houseRules.reminderFollowingRules',
            )}
          </p>
          <TextAreaField
            colSmInput={12}
            name="preview.houseRules"
            disabled
            rows={5}
            value={t(
              'pageAutomations.preArrivalForm.preview.houseRules.dummyText',
            )}
          />
          {shouldShowField(
            PreArrivalFormFields.OTHER_AGREE_HOUSE_RULES,
            <CheckboxField name="preview.agreeWithHouseRules">
              {t(
                'pageAutomations.preArrivalForm.preview.houseRules.agreeWithHouseRules',
              )}
            </CheckboxField>,
          )}
        </div>
      </HouseRulesContainer>

      <PreviewDivider />
    </>
  );
};

export default HouseRulesSection;
